import { EventBus } from '@vtblife/event-bus';
import { useCallback, useEffect, useState } from 'react';
const eventBus = EventBus.getInstance();
export const useEventSubscription = (eventType) => {
    const [showModal, setShowModal] = useState(false);
    const [eventData, setEventData] = useState();
    const onClose = useCallback(() => {
        setShowModal(false);
    }, []);
    useEffect(() => {
        const subscription = eventBus.subscribe(eventType, ({ data }) => {
            setEventData(data);
            setShowModal((showModal) => !showModal);
        }, {
            eventCategory: 'simple',
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [eventType, setShowModal]);
    return { isOpen: showModal, eventData, onClose };
};
//# sourceMappingURL=use-event-subscription.js.map